import ProgressRing from "@/components/units/ProgressRing/ProgressRing";

const Spinner = () => {

  return (
    <div className=" tw-flex tw-justify-center">
        <div className="tw-w-32 tw-h-32 tw-p-4">
        <ProgressRing
            size={"10px"}
            color="#75F7FF"
            backgroundColor="#fafafc"
            // inverted={true}
            animated={true}
            progress={0.7}
            offset={0}
            content=""
        />
        </div>
    </div>
  );
};

export default Spinner;
